<template>
  <div
    v-if="size !== 'size-mini'"
    :class="{[size]:size}"
    class="artwork-meta"
  >
    <Artwork />
    <MetaInfo />
  </div>
</template>

<script>
import Artwork from './Artwork'
import MetaInfo from './MetaInfo'
import Store from '../store'

export default {
  components: {
    Artwork,
    MetaInfo
  },
  data () {
    return { store: Store }
  },
  computed: {
    size () { return this.store.state.size }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints.scss';

.artwork-meta {
  display: flex;
  z-index: 1;

  .artwork {
    display: none;
    width: 100%;

    @media (min-width: $bp_xs) {
      display: block;
      height: 86px;
      margin-right: 16px;
      max-width: 86px;
    }
    @media (min-width: $bp_sm) {
      height: 164px;
      max-width: 164px;
      width: 164px;
    }
  }
  .meta-info {
    display: block;

    @media (min-width: $bp_sm) {
      display: none;
    }
  }
}
</style>
